import React from "react";
import { Clock, Store } from "lucide-react";

interface HeaderProps {
  dateLabel: string;
  selectedLojaId?: number;
  selectedLojaNome?: string;
}

export const Header: React.FC<HeaderProps> = ({
  dateLabel,
  selectedLojaId,
  selectedLojaNome,
}) => {
  return (
    <div className="mt-4 px-3 py-2 text-center sm:mt-8 sm:px-4 sm:py-3">
      <h1 className="mb-1 bg-gradient-to-r from-yellow-300 to-white bg-clip-text text-2xl font-black text-transparent sm:text-4xl">
        RANKING DE MONTAGEM
      </h1>
      <div className="mb-2 flex flex-col items-center justify-center gap-0.5 text-sm opacity-75 sm:flex-row sm:gap-2 sm:text-base">
        <span className="flex items-center gap-1.5">
          <Clock className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
          {dateLabel}
        </span>
        {selectedLojaId && selectedLojaNome && (
          <>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center gap-1.5">
              <Store className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              {selectedLojaNome}
            </span>
          </>
        )}
      </div>
    </div>
  );
};
